// extracted by mini-css-extract-plugin
export var equalColumn = "_gw-0";